import React from 'react';
import { useTranslation } from 'react-i18next';
import { TeamMember } from '../../types';
import styles from './TeamMemberCard.module.css';

interface TeamMemberCardProps {
  member: TeamMember;
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ member }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <img
        src={member.imageUrl}
        alt={t(member.nameKey)}
        className={styles.avatar}
      />
      <h3 className={styles.name}>{t(member.nameKey)}</h3>
      <p className={styles.role}>{t(member.roleKey)}</p>
      <p className={styles.bio}>{t(member.bioKey)}</p>
      {(member.email || member.phone) && (
        <div className={styles.contact}>
          {member.email && (
            <a href={`mailto:${member.email}`} className={styles.contactLink}>
              {member.email}
            </a>
          )}
          {member.phone && (
            <a href={`tel:${member.phone}`} className={styles.contactLink}>
              {member.phone}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default TeamMemberCard;
